import { getFirestore, connectFirestoreEmulator } from "@firebase/firestore";
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import {
  beforeAuthStateChanged,
  connectAuthEmulator,
  getAuth,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { preferSignedInPersistedAccount, shouldBlockAnonymousTakeover } from "./authSessionPriority";

const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || 'living-wire-cb691';

const app = initializeApp({
  apiKey: "AIzaSyDQvBCLQz6tlqMhI1I1oH7OICgTZAPQV3U",
  authDomain: "living-wire-cb691.firebaseapp.com",
  projectId,
  storageBucket: "living-wire-cb691.firebasestorage.app",
  messagingSenderId: "585816728406",
  appId: "1:585816728406:web:cc648c03055d5a03976cf7",
  measurementId: "G-B1KBLQMGV3",
});

if (process.env.REACT_APP_USE_FIREBASE_EMULATORS !== "true") {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LeELZ0sAAAAAMIM7ETiPaIesohyqbH4gpmE9ejz"),
    isTokenAutoRefreshEnabled: true,
  });
}

// Open the auth database before getAuth so a signed-in account can replace an
// anonymous record in the shared persistence key before Auth reads it.
const persistedAccountReady = preferSignedInPersistedAccount(app.options.apiKey || '', app.name);

export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, "us-central1");
export const db = getFirestore(app);

beforeAuthStateChanged(auth, (nextUser) => {
  if (shouldBlockAnonymousTakeover(auth.currentUser, nextUser)) {
    throw new Error('A signed-in account cannot be replaced by an anonymous session.');
  }
});

// Only connect to emulators when explicitly requested.
if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true") {
  console.info("Connecting to emulators");
  connectFunctionsEmulator(functions, "127.0.0.1", Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001));
  connectFirestoreEmulator(db, "127.0.0.1", Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080));
  connectAuthEmulator(auth, `http://127.0.0.1:${process.env.REACT_APP_AUTH_EMULATOR_PORT || 9099}`, { disableWarnings: true });
}

/**
 * Resolves once persisted auth has been reconciled and the initial user is known.
 * Auth already persists locally. Switching that store on startup deletes the
 * current key while IndexedDB is still polling, which signs the user out and
 * lets a later anonymous sign-in take the key.
 */
export const authPersistenceReady = persistedAccountReady.then(() => auth.authStateReady());
